export default {
  targetYear: "{0}年度",
  quarter: "第{0}四半期",
  half: "第{0}半期",
};
